import { render, staticRenderFns } from "./TotalCost.vue?vue&type=template&id=dd052528&scoped=true"
import script from "./TotalCost.vue?vue&type=script&lang=js"
export * from "./TotalCost.vue?vue&type=script&lang=js"
import style0 from "./TotalCost.vue?vue&type=style&index=0&id=dd052528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd052528",
  null
  
)

export default component.exports